export enum InvoiceStatusEnum {
    Draft,
    PendingReview,
    PendingSend,
    PendingPayment,
    Partial,
    Overdue,
    Paid,
    CompletelyPaid,
    PendingApproval,
    PaymentSubmitted,
    Void,
    RevisionRequested,
    Unknown,
    ReviewRevisionRequested,
    Closed
  }

  export enum InvoiceTermEnum {
    DueOnReceipt = 1,
    Net15,
    Net30,
    Net60,
    Net90,
    custom
  }

  export class EmailHelper {
    public static readonly EmailKeywords = {
      CustomerName: '[CUSTOMER NAME]',
      CompanyName: '[COMPANY NAME]',
      CompanyPhone: '[COMPANY PHONE]',
      CompanyEmail: '[COMPANY EMAIL]',
      EstimateWord: '[ESTIMATE WORD]',
      EstimateNumber: '[ESTIMATE NUMBER]',
      EstimateLink: '[ESTIMATE LINK]',
      EstimateDate: '[ESTIMATE DATE]',
      InvoiceDueDate: '[INVOICE DUE DATE]',
      InvoiceLink: '[INVOICE LINK]',
      InvoiceNumber: '[INVOICE NUMBER]'
    }
    static readonly defaultInvoiceEmailTemplate = `Dear ${EmailHelper.EmailKeywords.CustomerName},<br><br>Thank you for choosing<br><br>Payment Due: ${EmailHelper.EmailKeywords.InvoiceDueDate}&nbsp;<br>&NoBreak;&NoBreak;&NoBreak;&NoBreak;&NoBreak;&NoBreak;&NoBreak;<br>${EmailHelper.EmailKeywords.CompanyName}<br><br>Feel free to contact us if you have any questions.<br>We look forward to working with you.<br><br>Best regards,<br><br>${EmailHelper.EmailKeywords.InvoiceDueDate}<br>${EmailHelper.EmailKeywords.CompanyPhone}<br>${EmailHelper.EmailKeywords.CompanyEmail}${EmailHelper.EmailKeywords.InvoiceLink}${EmailHelper.EmailKeywords.InvoiceDueDate}`;

  }

  export const PaymentProcessorOnboardingStatusTypes =
    {
        OnboardingNotStarted : "OnboardingNotStarted", 
        LegalEntityCreated : "LegalEntityCreated", 
        MerchantAccountCreated :"MerchantAccountCreated", 
        ControllerEmailSent : "ControllerEmailSent",
        OnboardingInProgress : "OnboardingInProgress",
        OnboardingCompleted : "OnboardingCompleted"
    }

export const PUBLISH_STATUSES = [
  InvoiceStatusEnum.PendingApproval,
  InvoiceStatusEnum.PendingPayment,
  InvoiceStatusEnum.Overdue,
  InvoiceStatusEnum.Partial
];

export const APPROVED_STATUSES = [
  InvoiceStatusEnum.Paid,
  InvoiceStatusEnum.CompletelyPaid,
  InvoiceStatusEnum.PaymentSubmitted
];

export const UNPUBLISH_STATUSES = [
  InvoiceStatusEnum.Draft,
  InvoiceStatusEnum.PendingReview,
  InvoiceStatusEnum.PendingSend,
  InvoiceStatusEnum.Void,
  InvoiceStatusEnum.RevisionRequested,
  InvoiceStatusEnum.Unknown,
  InvoiceStatusEnum.ReviewRevisionRequested
];